module.exports = __webpack_public_path__ + "static/lliira-DND3_FnP-22562efc7f90e820a90273ac81dd7f78.webp";